/* eslint-disable react-hooks/exhaustive-deps */
import Input from 'antd/lib/input';
import { useCallback, useMemo } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { useAppContext } from 'src/app/state';
import { ActionType } from 'src/app/state/action-type.enum';
import { DropdownOption } from 'src/types/dropdown.types';
import DropdownPopUpContent from './DropdownPopUpContent';

type DropdownProps = {
  options: DropdownOption[];
  placeholder?: string;
  value: DropdownOption | null;
  label?: string;
  onChange: (option: DropdownOption) => void;
  disabled?: boolean;
};

const Dropdown = ({
  options,
  placeholder = '',
  value,
  label,
  disabled = false,
  onChange,
}: DropdownProps) => {
  const {
    dispatch,
    state: { isPopUpOpened },
  } = useAppContext();

  const PopUpContent = useMemo(
    () => () => (
      <DropdownPopUpContent
        options={options}
        value={value}
        onChange={onChange}
      />
    ),
    [options, value, onChange]
  );

  const setUpPopUp = useCallback(() => {
    dispatch({
      type: ActionType.SET_POP_UP_HEADER,
      payload: { popUpHeader: label ?? '' },
    });
    dispatch({
      type: ActionType.SET_POP_UP_CONTENT,
      payload: { PopUpContent: PopUpContent },
    });
    dispatch({
      type: ActionType.SET_POP_UP_FOOTER,
      payload: { PopUpFooter: undefined },
    });
  }, []);

  const handlePopUpOpen = useCallback(() => {
    setUpPopUp();
    dispatch({ type: ActionType.POP_UP_OPEN, payload: {} });
  }, []);

  return (
    <Input
      size='large'
      placeholder={placeholder}
      value={value?.value || ''}
      onClick={disabled ? () => undefined : handlePopUpOpen}
      disabled={isPopUpOpened || disabled}
      suffix={
        <IoIosArrowDown
          onClick={disabled ? () => undefined : handlePopUpOpen}
        />
      }
    />
  );
};

export default Dropdown;
